import {
  Autocomplete as MuiAutocomplete,
  AutocompleteProps,
} from '@mui/material'

const Autocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
): JSX.Element => {
  return <MuiAutocomplete {...props} />
}

export { Autocomplete }
